import * as constants from '../constants/constants';
import {
  DEFAULT_MENU_DAYS_COUNT,
  DEFAULT_WEIGHT_GENERATION,
  DEFAULT_CALORIES_GENERATION,
  getDefaultMenu,
} from '../constants/appConstants';

const defaultStore = {
  templateName: '',
  templateDescription: '',
  templateTagsFilters: [],
  templateParametersCategories: [],
  countTemplateDays: DEFAULT_MENU_DAYS_COUNT,
  templateSameDaysCount: '0',
  chosenTemplateEatings: [],
  isTempaleWasEdited: false,
  // template menu block properties
  templateTabSelected: 0,
  menuTemplateGenerator: getDefaultMenu(),
  templateGenerationWeight: DEFAULT_WEIGHT_GENERATION,
  templateGenerationCalories: DEFAULT_CALORIES_GENERATION,
  genderValue: '',
  userCurrentDay: 0,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case constants.CHANGE_TEMPLATE_NAME:
      return {
        ...state,
        templateName: action.payload.templateName,
      };
    case constants.SET_TEMPLATE_TAGS_FILTERS:
      return {
        ...state,
        templateTagsFilters: action.payload.templateTagsFilters,
      };
    case constants.SET_TEMPLATE_PARAMETERS_CATEGORIES:
      return {
        ...state,
        templateParametersCategories: action.payload.templateParamTagsFilters,
      };
    case constants.CHANGE_TEMPLATE_MENU_DAYS:
      return {
        ...state,
        countTemplateDays: action.payload.countDays,
      };
    case constants.CHANGE_TEMPLATE_SAME_DAYS_COUNT:
      return {
        ...state,
        templateSameDaysCount: action.payload.templateSameDaysCount,
      };
    case constants.SET_TEMPLATE_DAY_TAB:
      return {
        ...state,
        templateTabSelected: action.payload.number,
      };
    case constants.SET_CHOSEN_TEMPLATE_EATINGS:
      return {
        ...state,
        chosenTemplateEatings: action.payload.chosenTemplateEatings,
      };
    case constants.SET_MENU_TEMPLATE_GENERATOR:
      return {
        ...state,
        menuTemplateGenerator: action.payload.menuTemplateGenerator,
      };
    case constants.SET_TEMPLATE_GENERATION_WEIGHT:
      return {
        ...state,
        templateGenerationWeight: action.payload.templateGenerationWeight,
      };
    case constants.SET_TEMPLATE_GENERATION_CALORIES:
      return {
        ...state,
        templateGenerationCalories: action.payload.templateGenerationCalories,
      };
    case constants.SET_GENDER_VALUE:
      return {
        ...state,
        genderValue: action.payload.genderValue,
      };
    case constants.CHANGE_TEMPLATE_DESCRIPTION:
      return {
        ...state,
        templateDescription: action.payload.templateDescription,
      };
    case constants.SET_USER_CURRENT_DAY:
      return {
        ...state,
        userCurrentDay: action.payload.currentMenuDay,
      };
    case constants.IS_TEMPLATE_WAS_EDITED:
      return {
        ...state,
        isTempaleWasEdited: action.payload.isTempaleWasEdited,
      };
    case constants.RESET_TEMPLATE_DATA:
      return {
        ...state,
        templateName: '',
        templateDescription: '',
        templateTagsFilters: [],
        templateParametersCategories: [],
        countTemplateDays: DEFAULT_MENU_DAYS_COUNT,
        templateSameDaysCount: '0',
        chosenTemplateEatings: [],
        templateTabSelected: 0,
        menuTemplateGenerator: getDefaultMenu(7),
        templateGenerationWeight: DEFAULT_WEIGHT_GENERATION,
        templateGenerationCalories: DEFAULT_CALORIES_GENERATION,
        genderValue: '',
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/templateGenerator.js